module.exports = __webpack_public_path__ + "img/text04.e6b3d68a.svg";